import clsx from 'clsx';
import React from 'react';

import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import LazyImgixImage from '@components/LazyImgixImage';
import { getArticleImgSrc } from '@utils/images';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import OrgChartImage from '../OrgChartImage';
import PictureCaption, { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import Content from './Content';
import Video from './Video';

const Standard = ({
  article: {
    addendum,
    authors,
    commentCount,
    commenters,
    freeBlurb,
    fullText,
    highlight,
    id,
    isPro,
    media,
    orgChartImage,
    orgChartUrl,
    pickups,
    picture,
    pictureCaption,
    publishedAt,
    subTitle,
    takeaway,
    title,
  },
  canShareArticle,
  canViewFullArticle,
  clipperProps,
  env,
  isSEOBot,
  mostPopularArticles,
  newsletter,
  relatedArticles,
  subscriberCouncil,
}: ThemeViewsProps) => {
  return (
    <div className="px-16 sm:px-28">
      <div className="relative m-auto max-w-container-lg">
        <div className="mb-24 flex flex-col items-center justify-between sm:mb-48 lg:mb-72">
          <div className="z-10 mb-32 w-full flex-1 sm:mb-48 lg:mb-32">
            <Header highlight={highlight} title={title} subTitle={subTitle} />
          </div>
          {!media ? (
            <figure className="relative m-0 aspect-[16/9] w-full" aria-labelledby="caption-text">
              {isPro && (
                <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />
              )}
              {orgChartImage ? (
                <OrgChartImage
                  alt={title}
                  className="article-hero-image aspect-[16/9] h-auto w-full"
                  orgChartImage={orgChartImage}
                  orgChartUrl={orgChartUrl}
                  wrapperClassName="!flex"
                />
              ) : (
                <LazyImgixImage
                  alt={title}
                  className="article-hero-image aspect-[16/9] h-auto w-full"
                  src={getArticleImgSrc(id, picture, env)}
                  wrapperClassName="!flex"
                />
              )}
              <PictureCaption className="block !w-full" pictureCaption={pictureCaption} />
            </figure>
          ) : (
            <Video canViewFullArticle={canViewFullArticle} media={media} />
          )}
        </div>
        <div className="relative m-auto lg:max-w-[1060px] xl:max-w-container-lg">
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="z-10 flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <ArticleDetails
                  authors={authors}
                  commentCount={commentCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  canShareArticle={canShareArticle}
                  articleId={id}
                />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden md:block md:w-[195px] md:flex-shrink-0 lg:w-[260px]'
              )}
            />
          </div>
          <Content
            addendum={addendum}
            authors={authors}
            canViewFullArticle={canViewFullArticle}
            clipperProps={clipperProps}
            commentCount={commentCount}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            id={id}
            isSEOBot={isSEOBot}
            mostPopularArticles={mostPopularArticles}
            newsletter={newsletter}
            pickups={pickups}
            relatedArticles={relatedArticles}
            subscriberCouncil={subscriberCouncil}
            takeaway={takeaway}
          />
        </div>
      </div>
    </div>
  );
};

export default Standard;
